import { Flex, Grid, SimpleInput, Typography } from '@aloft/toolkit-sui';

import { Controller } from 'react-hook-form';

import { useZodFormContext } from '../../hooks/useZodForm.ts';
import { DepreciationToggle } from './DepreciationToggle.tsx';

const FEATURE_AREA_FIELDS = [
  { key: 'garage', label: 'Attached Garage' },
  { key: 'attic', label: 'Attic' },
  { key: 'barn', label: 'Barn' },
  { key: 'carport', label: 'Carport' },
  { key: 'deck', label: 'Deck' },
  { key: 'detachedGarage', label: 'Detached Garage' },
  { key: 'patio', label: 'Patio' },
  { key: 'pool', label: 'Pool' },
  { key: 'porch', label: 'Porch' },
  { key: 'shed', label: 'Shed' },
  { key: 'spa', label: 'Spa' },
  { key: 'workshop', label: 'Workshop' },
] as const;

export const DefaultFeatureAreas = () => {
  const { control } = useZodFormContext();

  return (
    <Flex flexDirection="column" gap="1.5rem" width="100%">
      <Flex flexDirection="column" gap="1rem" width="100%">
        <Typography variant="h3">
          Set default area estimates for each feature, in square feet:
        </Typography>
        <Grid gridTemplateColumns="repeat(3, 1fr)" gap="0.5rem" width="100%">
          {FEATURE_AREA_FIELDS.map(({ key, label }) => (
            <Controller
              key={key}
              name={`defaultFeatureAreas.${key}`}
              control={control}
              render={({ field, fieldState }) => (
                <Flex flexDirection="column" gap="0.5rem" width="100%">
                  <Typography variant="h4" color="textSecondary">
                    {label}
                  </Typography>
                  <SimpleInput
                    size="md"
                    type="number"
                    precision={0}
                    {...field}
                    value={field.value?.toString() ?? ''}
                    invalid={!!fieldState.error}
                    errorMessage={fieldState.error ? 'Required' : undefined}
                  />
                </Flex>
              )}
            />
          ))}
        </Grid>
      </Flex>
      <DepreciationToggle
        question="Show area on the feature grid?"
        trueLabel="Yes"
        falseLabel="No"
        fieldName="showFeatureAreasOnGrid"
        forceHorizontal
        trueFirst
      />
    </Flex>
  );
};
